module.exports = __webpack_public_path__ + "static/media/check.4856ed48.png";